/* ==========================================================================
   Chrune promotions

   This file never calculates a discount. It applies a real Shopify discount
   code and leaves every amount to what Shopify computes for the cart.

   The ring offer is not handled here at all. It is the automatic Shopify
   discount, and the cart only links to the ring product page, where the ring
   is configured and added like any other piece.

   One job: the newsletter popup. The welcome code is never written into the
   page before the visitor has subscribed: Shopify renders it only in the
   answer to a successful subscription, and this file applies it to the cart.
   Once applied it appears in the cart summary as a discount row, read back
   from Shopify.

   The popup waits for the cookie consent banner to be answered, so a first
   visit never stacks two dialogs on top of each other.
   ========================================================================== */
(function () {
  'use strict';

  var SEEN_KEY = 'chrune_popup_seen';

  function read(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* private mode: the popup may simply show again */
    }
  }

  function onCartPage() {
    return !!document.querySelector('[data-cart-root]');
  }

  /* ------------------------------------------------------------------ *
   * Newsletter popup
   *
   * The form posts natively to Shopify. This only reacts to the result.
   * ------------------------------------------------------------------ */

  var lastFocus = null;

  function openPopup(popup) {
    lastFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    var email = popup.querySelector('[data-promo-email], #PromoPopupEmail');
    if (email && !email.disabled) email.focus();
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    var seen = read(SEEN_KEY) || {};
    seen.at = Date.now();
    write(SEEN_KEY, seen);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showSuccess(popup, code) {
    var formView = popup.querySelector('[data-promo-view="form"]');
    var successView = popup.querySelector('[data-promo-view="success"]');
    var codeNode = popup.querySelector('[data-promo-code]');
    if (codeNode) codeNode.textContent = code;
    if (formView) formView.hidden = true;
    if (successView) successView.hidden = false;
  }

  /* Shopify redirected back after a successful subscribe and rendered the
     marker, the only place the code is written. Apply it once, then show the
     panel. The redirect keeps customer_posted=true in the URL, so a reload
     lands here again: the code is applied the first time only, which also
     keeps the cart page reload below from looping. */
  function handleSubscribed(popup) {
    var marker = document.querySelector('[data-promo-subscribed]');
    var code = marker && marker.getAttribute('data-code');
    if (!code) return false;

    showSuccess(popup, code);
    openPopup(popup);

    var seen = read(SEEN_KEY);
    if (seen && seen.subscribed) return true;

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        write(SEEN_KEY, { at: Date.now(), subscribed: true });
        if (onCartPage()) window.setTimeout(function () { window.location.reload(); }, 1200);
      })
      .catch(function () {});

    return true;
  }

  /* Shopify's own consent banner is a dialog of its own. Opening the popup
     while it is still on screen would cover one dialog with another. */
  function consentPending() {
    var banner = document.querySelector('.shopify-pc__banner__dialog');
    if (!banner) return false;
    var style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
  }

  function openWhenFree(popup, delay) {
    window.setTimeout(function wait() {
      if (read(SEEN_KEY)) return;
      if (consentPending()) {
        window.setTimeout(wait, 1000);
        return;
      }
      openPopup(popup);
    }, delay);
  }

  /* ------------------------------------------------------------------ *
   * Wiring
   * ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-promo-close]');
    if (closeButton) {
      var popup = closeButton.closest('[data-promo-popup]');
      if (popup) closePopup(popup);
      return;
    }

    /* Clicking the dimmed area closes, the panel itself does not. */
    if (event.target.hasAttribute && event.target.hasAttribute('data-promo-popup')) {
      closePopup(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var popup = document.querySelector('[data-promo-popup].is-open');
    if (popup) closePopup(popup);
  });

  function boot() {
    var popup = document.querySelector('[data-promo-popup]');
    if (!popup) return;
    if (handleSubscribed(popup)) return;
    if (read(SEEN_KEY)) return;
    openWhenFree(popup, (parseFloat(popup.getAttribute('data-delay')) || 2) * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();